import React from 'react';
import './SearchBar.css';
import searchIcon from '../../assets/new-images/search-icon.svg';
import closeIcon from '../../assets/new-images/outline-close-icon.svg';
import { useConstants } from '../../constant/constantProvider';

const SearchBar = ({ value, onChange, onClear, placeholder, className = "", disabled = false, infoNote = null }) => {
  const { SEARCH_HERE } = useConstants();
  return (
    <div className={`search-bar-root ${disabled ? 'disabled' : ''} ${className}`}>
      <div className="search-wrapper">
        <img src={searchIcon} className="search-icon" alt="search" />
        <input
          type="text"
          placeholder={placeholder || SEARCH_HERE || "Search here"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        />
        {value && (
          <button
            className="clear-search-btn"
            onClick={() => onClear ? onClear() : onChange('')}
            aria-label="Clear search"
            disabled={disabled}
          >
            <img src={closeIcon} alt="clear" />
          </button>
        )}
      </div>
      {infoNote && (
        <p className="search-bar-info-note">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="12" height="12" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          {infoNote}
        </p>
      )}
    </div>
  );
};

export default SearchBar;
